import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n/index';
import * as serviceWorker from './serviceWorker';
import { initializeIcons } from '@fluentui/react';
import { App } from './App';

initializeIcons();

document.title = 'DIHK - Datenverstoß melden';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
